import { render, staticRenderFns } from "./u-scroll-top.vue?vue&type=template&id=6ea75ea5&"
import script from "./u-scroll-top.vue?vue&type=script&lang=js&"
export * from "./u-scroll-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports